import React from "react";

const defaultValue = {
  locale: 'fr',
  setLocale: () => {} 
}

export default React.createContext(defaultValue);